import { deserializeAccount } from './deserialize-account';
import { serializeAccount } from './serialize-account';
import {
  AccountResponseT,
  AccountT,
  AccountUpdateRequestT,
} from '../../types';
import { TransformT } from '../../types/transform';

export const accountTransform: TransformT<AccountT, AccountResponseT, AccountUpdateRequestT> = {
  deserialize: deserializeAccount,
  serialize: serializeAccount,
};
